import "core-js/modules/es.array.push.js";
import DcModal from '../../../ui/modal/DcModal.vue';
import ApiClient from '@/plugins/AxiosPlugin';
import LoadingDots from '@/dow-platform/components/commerce/shared/loading-dots/index.js';
import CheckBox from '../../blocks/input-elements/checkbox/CheckBox.vue';
import { ChevronIcon } from '../../blocks/svg-elements/chevron-icon';
export default {
  name: 'OrderSummary',
  emits: ['emptyCartFailure', 'saveFailure', 'updateEntries'],
  props: {
    cartData: {
      type: Object,
      required: true
    },
    removeMessage: {
      type: String,
      required: true
    },
    poNum: {
      type: String,
      required: false
    },
    isButtonDisabled: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      isCheckoutDisabled: true,
      showEmptyCartModal: false,
      loading: false,
      isMultiPO: this.cartData?.cartData.isMultiPO,
      isIndia: this.cartData?.isIndia,
      isExchangeMessage: this.cartData?.isExchangeMessage,
      creditCardSelected: false,
      showSimulateErrorModal: false,
      simulateErrorMessages: [],
      displayTotalsByPo: this.cartData?.cartData?.totalsByPo?.length <= 5,
      hasClickedCheckout: false
    };
  },
  watch: {
    cartData: {
      immediate: true,
      handler(newVal) {
        if (newVal && newVal.cartData && newVal.cartData.totalsByPo) {
          this.displayTotalsByPo = newVal.cartData.totalsByPo.length <= 5;
        }
      }
    },
    lineItemNumbersToSave: {
      immediate: true,
      handler(newVal) {
        if (newVal && newVal.length === 0 && this.hasClickedCheckout) {
          this.submitInput();
        }
      }
    }
  },
  components: {
    CheckBox,
    DcModal,
    LoadingDots,
    ChevronIcon
  },
  mounted() {
    this.creditCardSelected = this.isOnlyCreditCardPayment() || this.creditCardSelect();
  },
  computed: {
    totalsByPo() {
      return this.cartData?.cartData.totalsByPo || [];
    },
    hasTotalsByPo() {
      return this.totalsByPo.length > 0;
    },
    hasMultipleSubtotals() {
      return this.cartData?.cartData.totalsByCurrencies.length > 1;
    },
    lineItemNumbersToSave() {
      return this.$store.getters['cart/getLineItemNumbersToSave'];
    },
    cartCount() {
      return this.$store.state.user.dccUserInfo?.data?.numberOfCartItems || 0;
    }
  },
  methods: {
    getLabel: function (key) {
      return window.Granite.I18n.get(key);
    },
    subTotals: function () {
      return this.cartData?.cartData.totalsByCurrencies.map(total => total.subtotalAmountFormatted);
    },
    getCurrencies: function () {
      return this.cartData?.cartData.totalsByCurrencies.map(total => total.currency);
    },
    canPayByCreditCard: function () {
      return this.cartData?.canPayByCreditCard;
    },
    isOnlyCreditCardPayment: function () {
      return this.cartData?.isOnlyCreditCardPayment;
    },
    creditCardSelect: function () {
      return this.cartData?.cartData?.creditCardSelect;
    },
    hasItemsInCart: function () {
      return typeof this.cartData === 'undefined' ? false : true;
    },
    toggleModal: function () {
      this.showEmptyCartModal = !this.showEmptyCartModal;
    },
    toggleSimulateModal: function () {
      this.showSimulateErrorModal = !this.showSimulateErrorModal;
    },
    removeAll() {
      this.loading = true;
      ApiClient.get(this.$store.state.settings.remove_cart_servlet, {
        params: {
          removeAll: true
        },
        headers: {
          'Content-Type': 'application/json'
        }
      }).then(function (response) {
        this.loading = false;
        this.updateCartCount();
        window.location.reload();
      }.bind(this)).catch(error => {
        this.loading = false;
        this.$emit('emptyCartFailure', true);
        console.error('Error', error);
      });
      console.log("Submit Empty Cart");
    },
    updateCartCount() {
      if (this.isEditMode !== 'true') {
        this.$store.state.user.dccUserInfo.data.numberOfCartItems = 0;
      }
    },
    onCheckoutClicked() {
      this.hasClickedCheckout = true;
      this.submitInput();
    },
    submitInput() {
      // This checks the array in the Vue store of cart data that is potentially saving
      // Need to make sure that it finishes before continuing with the checkout logic
      // A watcher in this component will watch that array and call this function again when the update finishes and clears that array
      if (this.lineItemNumbersToSave && this.lineItemNumbersToSave.length > 0) {
        return;
      } else {
        this.hasClickedCheckout = false;
        this.$emit("checkoutClicked");
        let invalidEntries = this.cartData?.cartData?.entries?.filter(entry => {
          return entry.isPoInvalid;
        });
        if (invalidEntries.length > 0) {
          return;
        }
        this.trackCheckout();
        //Submit Checkout changes
        this.saveDetailsAndRoute();
      }
    },
    getPricingErrorMessage(message) {
      const itemLen = message.indexOf('-');
      const itemNumber = itemLen !== -1 ? message.substring(0, itemLen) : '';
      const errorMessage = this.getLabel('drawer.no.pricing.in.range');
      return itemNumber + ' ' + errorMessage;
    },
    toggleTotalsByPo() {
      this.displayTotalsByPo = !this.displayTotalsByPo;
    },
    trackCheckout() {
      const products = this.cartData?.cartData?.entries?.map(entry => ({
        gmid: entry.materialNumber,
        SKU: entry.materialNumber,
        name: entry.myPartDescription || entry.salesText,
        quantity: entry.displayQuantity || entry.quantity
      }));
      if (products) {
        this.$store.dispatch('pdp/checkoutTracking', {
          products,
          event: 'commerce.checkouts'
        });
      }
    },
    async saveDetailsAndRoute() {
      this.loading = true;
      const url = this.$store.state.settings.checkout_servlet;
      //save CC option
      const creditCardSelect = this.creditCardSelected || this.isOnlyCreditCardPayment();
      const inputData = {
        creditCardSelect
      };
      const data = new FormData();
      data.append('inputData', JSON.stringify(inputData));
      try {
        const res = await ApiClient.post(url, data, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        });
        this.loading = false;
        const responseData = res.data;
        if (responseData?.errorMessages) {
          this.simulateErrorMessages = responseData.errorMessages;
          this.showSimulateErrorModal = true;
          this.$emit('updateEntries', responseData?.entries);
        } else {
          this.routeAfterSave(creditCardSelect);
        }
      } catch (error) {
        this.loading = false;
        console.error('Saving details failed from cart', error);
        this.$emit('saveFailure', true);
      }
    },
    routeAfterSave(creditCardSelect) {
      if (creditCardSelect) {
        this.$router.push({
          name: "payment"
        });
      } else {
        this.$router.push({
          name: "checkout"
        });
      }
    }
  }
};